import { getRequiredFields } from "components/form/utils";
import { bookmarkSchema } from "./schema";
import { useForm } from "react-hook-form";
import { useMemo } from "react";
import { zodResolver } from "@hookform/resolvers/zod";
import { useCreateBookmark } from "../create/mutation";
import { useUpdateBookmark } from "../update/mutation";
import { fetchBookmarkDataForForm } from "./read";

export const useBookmarkForm = ({ form, bookmark_folder, handleDialogClose } = {}) => {
    const createBookmarkMutation = useCreateBookmark({ bookmark_folder });
    const updateBookmarkMutation = useUpdateBookmark();


    const requiredFields = useMemo(
        () => getRequiredFields(bookmarkSchema),
        []
    );

    const handleCreate = async (context) => {
        const values = context.values;

        const response = await createBookmarkMutation.mutateAsync({
            values,
        });

        form.reset();
        handleDialogClose();
    };

    async function handleRead(id) {
        const response = await fetchBookmarkDataForForm({ id });

        return {
            ...response,
            description: response.description || "",
        };
    }

    async function handleUpdate(id, context) {
        const values = context.dirtyValues;
        await updateBookmarkMutation.mutateAsync({ id, values });
        form.reset();

        handleDialogClose();
        // navigate(`/work/projects/${project_slug}/bookmarks`);
    }

    return {
        form,
        requiredFields,
        handleCreate,
        handleRead,
        handleUpdate,
    };
};
